<template>
  <ckeditor v-if="contenteditable" :editor="editor" v-model="val" :config="editorConfig" @focus="onEditorFocus" @blur="onUpdated" @ready="onEditorReady" class="bc-ck-editor -text-content"></ckeditor>
  <div v-else v-html="val" class="-text-content"></div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import InlineEditor from '@/frontapp/ckeditor'
import debounce from 'lodash/debounce'

export default {
  emits: ['update:modelValue', 'updated'],
  props: {
    contenteditable: {
      type: Boolean,
      default: true,
    },
    modelValue: String,
    alwaysSelectAll: {
      type: [Boolean, String],
      default: false,
    },
    autoFocus: Boolean,
  },
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component
  },
  data () {
    return {
      editor: InlineEditor,
      editorConfig: {
        toolbar: {
          viewportTopOffset: 120
        },
      },
      currentContent: this.$props.modelValue,
    }
  },
  computed: {
    val: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
        this.keypressUpdate()
      }
    }
  },
  methods: {
    onEditorReady(editor) {
      if (this.autoFocus) {
        editor.editing.view.focus()
      }
    },
    onEditorFocus(eventInfo, editor) {
      if (editor) {
        if (this.alwaysSelectAll === true || this.alwaysSelectAll === this.val) {
          setTimeout(() => {
            editor.execute('selectAll')
          }, 10)
        }
      }
    },
    onUpdated() {
      const curContent = this.modelValue;
      if (this.currentContent !== curContent) {
        this.$emit('updated', true)
        this.currentContent = curContent
      }
    }
  },
  mounted() {
    this.keypressUpdate = debounce(() => {
      this.onUpdated()
    }, 1000)
  },
}
</script>

<style>
#snippet--app .bc-ck-editor.ck-editor__editable:not(.ck-editor__nested-editable) {
  padding: 0 0 !important;
  border: 0 !important;
  box-shadow: none !important;
}

#snippet--app .bc-ck-editor.ck.ck-editor__editable_inline>:last-child:not(:empty) {
  margin-bottom: 0;
}

#snippet--app .bc-ck-editor.ck.ck-editor__editable_inline>:first-child:not(:empty) {
  margin-top: 0;
}

.ck.ck-balloon-panel:not(.ck-toolbar-container) {
	z-index: 1001;
}
</style>
